import { oc } from '@orpc/contract';
import { checkVinInputSchema, checkVinOutputSchema } from '../schemas/estimates.schemas.js';
/**
 * Informational: another **open** estimate carrying the same normalised VIN is worth saying out loud
 * while the salesperson types, but nothing is refused. The stock-vehicle half arrives with inventory.
 */
export const checkEstimateVinContract = oc
    .route({
    method: 'GET',
    path: '/estimates/check-vin',
    tags: ['Estimates'],
    summary: 'Find open estimates that already carry this VIN',
})
    .input(checkVinInputSchema)
    .output(checkVinOutputSchema);
//# sourceMappingURL=check-estimate-vin.contract.js.map